import React, { FC, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { Social } from 'sections/Company/ContactUs/data';
import { Info } from 'sections/Company/ContactUs/components/Contact/Info';
import { InfoErp } from 'sections/Company/ContactUs/components/Contact/InfoErp';
import { Form } from 'sections/Company/ContactUs/components/Contact/Form';
import styles from 'sections/Company/ContactUs/components/Contact/Contact.module.scss';

const cn = classNames.bind(styles);

interface ContactProps {
  contact: any;
  page?: 'erp' | null;
};

const Contact: FC<ContactProps> = ({ contact, page }): React.ReactElement => {
  const [isAuth, setIsAuth] = useState<boolean>(false);

  useEffect(() => {
    if (contact.name && contact.email) {
      setIsAuth(true)
    };
  }, []);

  return (
    <>
      <div className={cn('contact')}>
        {page === 'erp'
          ?
          <InfoErp social={Social} />
          :
          <Info
            social={Social}
            visible={contact.addressVisible}
          />
        }

        <Form
          isAuth={isAuth}
          contact={contact}
          page={page}
        />
      </div>
    </>
  );
};

export { Contact };
